import React from 'react';
import ProjectTrackingComp from '../../../Components/ProjectTracking/ProjectTrackingComp';

const ProjectTracking = () => {
  return <ProjectTrackingComp />;
};

export default ProjectTracking;
